import SVG, { CustomSVGProps } from '@/src/components/common/SVG/SVG'

export default function SVGPhone(_: CustomSVGProps) {
  return (
    <SVG width="15" height="15" viewBox="0 0 15 15" fill="none" {..._}>
      <path
        d="M13.5031 10.2083L11.3864 9.96667C10.8781 9.90833 10.3781 10.0833 10.0197 10.4417L8.4864 11.975C6.12806 10.775 4.19473 8.85 2.99473 6.48333L4.53639 4.94167C4.89473 4.58333 5.06973 4.08333 5.01139 3.575L4.76973 1.475C4.66973 0.633334 3.9614 0 3.11139 0H1.66973C0.728062 0 -0.0552721 0.783333 0.00306123 1.725C0.444728 8.84167 6.1364 14.525 13.2447 14.9667C14.1864 15.025 14.9697 14.2417 14.9697 13.3V11.8583C14.9781 11.0167 14.3447 10.3083 13.5031 10.2083V10.2083Z"
        fill="currentColor"
      />
    </SVG>
  )
}
